import { render, staticRenderFns } from "./zsgl-app.vue?vue&type=template&id=a70dde90&scoped=true"
import script from "./zsgl-app.vue?vue&type=script&lang=js"
export * from "./zsgl-app.vue?vue&type=script&lang=js"
import style0 from "../../views/ksgl-page/assets/css/base.css?vue&type=style&index=0&id=a70dde90&prod&scoped=true&lang=css&external"
import style1 from "./zsgl-app.vue?vue&type=style&index=1&id=a70dde90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70dde90",
  null
  
)

export default component.exports